import React from 'react';

const Products = () => {
  return (
    <div className="page">
      <div className="container">
        <h1>Products Page</h1>
        <p>This is the products page. You can navigate here from the main menu.</p>
      </div>
    </div>
  );
};

export default Products;
